const courseCategoryRoutes = [
  {
    path: "/course-categories",
    component: () =>
      import(
        /* webpackChunkName: "course-layout-full-width" */ "@/views/course/Layout.vue"
      ),
    children: [
      {
        path: ":id",
        name: "CourseCategoryView",
        meta: { title: "View Course Category" },
        props: (route) => ({
          id: parseInt(route.params.id),
        }),
        component: () =>
          import(
            /* webpackChunkName: "course-category-view" */ "@/views/course-category/View.vue"
          ),
      },
    ],
  },
]

export default courseCategoryRoutes
